import { createSelector } from 'reselect';

import { getOpenWalletsArray } from 'Selectors/accounts';
import { getClientUsers } from 'Selectors/users';

import { getApiConnectionsArray } from './apiConnections';
import { getAPIFirmsArray, getFirmsArray } from './firms';

export const getBankOpsDashboardToolbarStats = createSelector(
    [ getFirmsArray, getOpenWalletsArray, getClientUsers ],
    (firms, accounts, clientUsers) => {
        const lockedFirms = firms.filter(firm => firm.IsLocked);
        const lockedEOAAccounts = accounts.filter(account => account.IsLocked);
        const lockedUsers = clientUsers.filter(user => user.IsLocked);
        const apiUsers = clientUsers.filter(user => user.IsTokenAPIUser);
        const lockedApiUsers = apiUsers.filter(user => user.IsLocked);

        return {
            firms: firms.length,
            lockedFirms: lockedFirms.length,
            eoaAccounts: accounts.length,
            lockedEOAAccounts: lockedEOAAccounts.length,
            activeClientUsers: clientUsers.length,
            lockedActiveClientUsers: lockedUsers.length,
            apiClientUsers: apiUsers.length,
            lockedApiClientUsers: lockedApiUsers.length
        };
    }
);

export type ApiOpsDashboardOverviewStats = {
    apiFirms: number;
    lockedApiFirms: number;
    apiUsers: number;
    lockedApiUsers: number;
    apiConnections: number;
    lockedApiConnections: number;
};

export const getApiOpsOverviewDashboardStats = createSelector(
    [ getAPIFirmsArray, getClientUsers, getApiConnectionsArray ],
    (apiFirms, clientUsers, apiConnections): ApiOpsDashboardOverviewStats => {
        const lockedApiFirms = apiFirms.filter((firm) => firm.IsLocked);
        const apiUsers = clientUsers.filter((user) => user.IsTokenAPIUser);
        const lockedApiUsers = apiUsers.filter((user) => user.IsLocked);
        const lockedApiConnections = apiConnections.filter((apiConnection) => apiConnection.IsLocked);

        return {
            apiFirms: apiFirms.length,
            lockedApiFirms: lockedApiFirms.length,
            apiUsers: apiUsers.length,
            lockedApiUsers: lockedApiUsers.length,
            apiConnections: apiConnections.length,
            lockedApiConnections: lockedApiConnections.length
        };
    }
);